<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="name">Номер квартиры (заканчивая)</label>
    <input
      type="text"
      class="form-control"
      id="name"
      placeholder="Введите номер"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'apartment-number-to-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ToApartmentNumber.vue?bf5a052a